import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onActivate, onDeactivate, onDelete, onExport, onClearSelection }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-1000 bg-card border border-border rounded-xl shadow-2xl px-6 py-4 flex items-center gap-4 transition-smooth">
      <div className="flex items-center gap-2">
        <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-full">
          <span className="text-sm font-bold text-primary">{selectedCount}</span>
        </div>
        <span className="text-sm font-medium text-foreground">
          {selectedCount} rota seçildi
        </span>
      </div>

      <div className="h-6 w-px bg-border" />

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onActivate}
          iconName="CheckCircle"
          iconPosition="left"
          iconSize={14}
        >
          Aktif Et
        </Button>

        <Button
          variant="outline"
          size="sm"
          onClick={onDeactivate}
          iconName="XCircle"
          iconPosition="left"
          iconSize={14}
        >
          Pasif Et
        </Button>

        <div className="relative">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            iconName="MoreVertical"
            iconSize={14}
          />

          {isDropdownOpen && (
            <>
              <div 
                className="fixed inset-0 z-10" 
                onClick={() => setIsDropdownOpen(false)}
              />
              <div className="absolute bottom-full right-0 mb-2 w-48 bg-card border border-border rounded-lg shadow-xl overflow-hidden z-20">
                <button
                  onClick={() => {
                    onExport();
                    setIsDropdownOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted transition-smooth text-left"
                >
                  <Icon name="Download" size={16} color="var(--color-foreground)" />
                  <span className="text-sm text-foreground">Dışa Aktar</span>
                </button>
                <button
                  onClick={() => {
                    onDelete();
                    setIsDropdownOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-4 py-3 hover:bg-destructive/10 transition-smooth text-left"
                >
                  <Icon name="Trash2" size={16} color="var(--color-destructive)" />
                  <span className="text-sm text-destructive">Sil</span>
                </button>
              </div>
            </>
          )}
        </div>

        <div className="h-6 w-px bg-border" />

        <button
          onClick={onClearSelection}
          className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-muted transition-smooth"
          aria-label="Seçimi temizle"
        >
          <Icon name="X" size={16} color="var(--color-foreground)" />
        </button>
      </div>
    </div>
  );
};

export default BulkActionsBar;